export default __webpack_public_path__ + "static/media/logo-header.35bd4e5b.png";